module.exports = __webpack_public_path__ + "static/img/whatsapp.ec69d1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/floating-button/whatsapp.png
// module id = 521b
// module chunks = 48